import { ICheckbookCard } from "@wingspanhq/payments/dist/interfaces";

export const selectorDebitCardName = (debitCard: ICheckbookCard) =>
  `Debit Card (${debitCard.last4})`;
